import { call, takeLatest, all, put } from 'redux-saga/effects';
import api from 'services/api';
// import Notifications from 'react-notification-system-redux';
import {
  Types,
  Creators as GlobalsStyleCreators,
} from 'store/ducks/globalsStatus/actions';
import { callApi } from 'store/sagas/auth';

function* getChangeStatus({ payload }) {
  try {
    const { itemId, status, name, attachmentId } = payload;
    const request = call(api.patch, `/v1/admin/globals/status/${itemId}`, {
      status,
      name,
    });

    const response = yield call(callApi, request);
    if (response.status !== 200) throw response;
    yield put(GlobalsStyleCreators.getSuccess(response.data));
    if (name === 'activity_attachments' && attachmentId) {
      const request2 = call(
        api.patch,
        `/v1/admin/globals/status/${attachmentId}`,
        {
          status,
          name: 'attachments',
        },
      );
      yield call(callApi, request2);
    }
    // yield put(Notifications.success({ title: response.data.msg }));
  } catch (err) {
    yield put(GlobalsStyleCreators.getFailure('Erro ao buscar na API'));
  }
}
function* getChangeExclusive({ payload }) {
  try {
    const { itemId, status, name, exclusive } = payload;
    const request = call(api.patch, `/v1/admin/globals/exclusive/${itemId}`, {
      status,
      name,
      exclusive,
    });

    const response = yield call(callApi, request);
    if (response.status !== 200) throw response;
    yield put(GlobalsStyleCreators.getSuccess(response.data));
    // yield put(Notifications.success({ title: response.data.msg }));
  } catch (err) {
    yield put(GlobalsStyleCreators.getFailure('Erro ao buscar na API'));
  }
}

function* getChangePremium({ payload }) {
  try {
    const { itemId, status, name, premium } = payload;
    const request = call(api.patch, `/v1/admin/globals/premium/${itemId}`, {
      status,
      name,
      premium,
    });

    const response = yield call(callApi, request);
    if (response.status !== 200) throw response;
    yield put(GlobalsStyleCreators.getSuccess(response.data));
    // yield put(Notifications.success({ title: response.data.msg }));
  } catch (err) {
    yield put(GlobalsStyleCreators.getFailure('Erro ao buscar na API'));
  }
}

export default function* moduleListSaga() {
  yield all([takeLatest(Types.GET_REQUEST, getChangeStatus)]);
  yield all([takeLatest(Types.GET_REQUEST_EXCLUSIVE, getChangeExclusive)]);
  yield all([takeLatest(Types.GET_REQUEST_PREMIUM, getChangePremium)]);
}
